import { TfiAngleLeft } from "react-icons/tfi";

export const AngleLeft = ({ ...rest }) => {
  return <TfiAngleLeft {...rest} />;
};
